module.exports = __webpack_public_path__ + "static/media/pbl-logo-login.2e17325c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pbl-logo-login.svg
// module id = 777
// module chunks = 0